import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';

class GuestStore extends BaseStore {
  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  use(props) {
    super.use(props);
    useMount(async () => {
      // 初始化逻辑
    });
  }
}

export default GuestStore;
